import { useState, useEffect, useContext } from "react";
import axios from "axios";
import { FriendContext } from "../helpers/FriendContext";
import animated_profile_picture from "../assets/animated_profile_picture.png";

function FriendRequests() {
  const { setFriends } = useContext(FriendContext);
  const [friendUsername, setFriendUsername] = useState("");
  const [errorMessage, setErrorMessage] = useState(null);
  const [friendRequests, setFriendRequests] = useState([]);

  const sendFriendRequest = () => {
    setErrorMessage(null); // Clear previous errors

    axios
      .get(`https://verbalvortex-server.onrender.com/auth/friendInfo/${friendUsername}`, {
        headers: {
          accessToken: localStorage.getItem("accessToken"),
        },
      })
      .then((response) => {
        if (response.data.error) {
          setErrorMessage(response.data.error);
        } else {
          const friendId = response.data.id;
          const friendFullname = response.data.fullname; // Assuming the response contains fullname
          const friendUsername = response.data.username; // Assuming the response contains username

          axios
            .post(
              "https://verbalvortex-server.onrender.com/friends",
              { friendId: friendId },
              {
                headers: {
                  accessToken: localStorage.getItem("accessToken"),
                },
              }
            )
            .then((response) => {
              if (response.data.error) {
                setErrorMessage(response.data.error);
              } else {
                alert("Friend Request Sent");

                // Add the new friend request to the state
                const newFriendRequest = {
                  id: friendId,
                  fullname: friendFullname,
                  username: friendUsername,
                  isSentByMe: true,
                };
                setFriendRequests((prevRequests) => [
                  ...prevRequests,
                  newFriendRequest,
                ]);
              }
            })
            .catch((error) => {
              setErrorMessage(
                "Error sending friend request. Please try again later."
              );
              console.error("Error sending friend request:", error);
            });
        }
      })
      .catch((error) => {
        setErrorMessage("User not found. Try again later.");
        console.error("Error finding friend:", error);
      })
      .finally(() => {
        setFriendUsername("");
      });
  };

  const acceptFriendRequest = (friendId) => {
    axios
      .put(
        `https://verbalvortex-server.onrender.com/friends/${friendId}/accept`,
        {},
        {
          headers: {
            accessToken: localStorage.getItem("accessToken"),
          },
        }
      )
      .then((response) => {
        alert("Friend request accepted");

        const newFriend = {
          id: response.data.id,
          fullname: response.data.fullname,
          username: response.data.username,
          score: response.data.score,
        };
        setFriends((prevFriends) => [...prevFriends, newFriend]);

        // Remove the accepted request from the state
        setFriendRequests((prevRequests) =>
          prevRequests.filter((request) => request.id !== friendId)
        );
      })
      .catch((error) => {
        setErrorMessage(
          "Error accepting friend request. Please try again later."
        );
        console.error("Error accepting friend request:", error);
      });
  };

  useEffect(() => {
    axios
      .get("https://verbalvortex-server.onrender.com/friends/pending", {
        headers: {
          accessToken: localStorage.getItem("accessToken"),
        },
      })
      .then((response) => {
        const pendingFriends = response.data.map((request) => ({
          id: request.isSentByMe ? request.friend.id : request.user.id,
          fullname: request.isSentByMe
            ? request.friend.fullname
            : request.user.fullname,
          username: request.isSentByMe
            ? request.friend.username
            : request.user.username,
          country: request.isSentByMe
            ? request.friend.country
            : request.user.country, // Agregar country
          isSentByMe: request.isSentByMe,
        }));
        setFriendRequests(pendingFriends);
      });
  }, []);

  return (
    <div className="FriendRequests">
      <div className="FriendRequests__SendRequest">
        <input
          placeholder="Type your friend's username"
          onChange={(event) => {
            setFriendUsername(event.target.value);
          }}
          type="text"
          value={friendUsername}
        />
        <button onClick={sendFriendRequest}>Send Friend Request</button>
        {errorMessage && <div className="error">{errorMessage}</div>}
      </div>
      <div id="FriendRequests__title">FRIEND REQUESTS</div>
      <hr />
      <div className="FriendRequests__Requests">
        {friendRequests.map((friendRequest) => (
          <div className="FriendRequests__Request">
            <div key={friendRequest.id}>
              <img src={animated_profile_picture} />
              <div>
                Full name:{" "}
                <p id="FriendRequests__Request__fullname">
                  {friendRequest.fullname}
                </p>
              </div>
              <div>Aka: {friendRequest.username} </div>
              <div>Country: {friendRequest.country}</div>{" "}
              {/* Mostrar country */}
              {friendRequest.isSentByMe ? (
                <div id="FriendRequests__RequestSent">Request Sent</div>
              ) : (
                <button
                  id="FriendRequests__AcceptRequest"
                  onClick={() => acceptFriendRequest(friendRequest.id)}
                >
                  Accept Friend Request
                </button>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default FriendRequests;
